// components/admin/editBioHelpers.js
//
// Photo-gallery cap helpers shared by AdminScreen (picker guard) and
// EditBioSheet (counter + grid), extracted so both read one source.

// KAN-98: max photos in a club's Photo Gallery via the Edit Club Bio flow
// (saved gallery URLs + anything staged this session, combined). This flow's
// save path (ClubService.updateClub) has never enforced a gallery-length
// cap of its own -- unlike HomeScreen.js's separate create-club flow, which
// has its own, lower MAX_GALLERY_IMAGES = 8 (screens/HomeScreen.js and
// services/clubService.js's club_applications sanitizeGalleryUrls/slice);
// that cap is a different flow and out of scope here. 18 is enforced only
// client-side, in pickGalleryImages below.
export const MAX_CLUB_GALLERY_PHOTOS = 18;

// Mirrors the Photo Gallery grid's own render filter, so the picker's
// selectionLimit/guard and the "x/18" counter never disagree with what the
// grid actually shows.
export function getVisibleStagedPhotoAssets(stagedPhotoAssets) {
  return (Array.isArray(stagedPhotoAssets) ? stagedPhotoAssets : []).filter(
    (asset) => !["removed", "cancelled", "cleanup-pending"].includes(asset.status)
  );
}
export function getClubGalleryPhotoCount(gallery, stagedPhotoAssets) {
  const galleryCount = Array.isArray(gallery) ? gallery.length : 0;
  return galleryCount + getVisibleStagedPhotoAssets(stagedPhotoAssets).length;
}
